export class BracketMetadata {
  rounds: number;
  playInTeamsTotal: number;
  capacityTeamsTotal: number;
  capacityRoundSlots: number;

  constructor(teams: number) {
    this.rounds = this.calculateRounds(teams);
    const prevRoundCapacity = this.getCapacity(this.rounds - 1);

    const remainder = teams - prevRoundCapacity;
    this.capacityTeamsTotal = prevRoundCapacity - remainder;
    this.playInTeamsTotal = (teams - prevRoundCapacity) * 2;

    // If we have a perfectly balanced bracket
    // (2, 4, 8, 16, 32, etc)
    if (this.playInTeamsTotal === teams) {
      this.capacityTeamsTotal = this.playInTeamsTotal;
      this.playInTeamsTotal = 0;
    }

    this.capacityRoundSlots =
      this.capacityTeamsTotal + this.playInTeamsTotal / 2;
  }

  private getCapacity(round: number) {
    return 2 ** round;
  }

  private calculateRounds(teams: number) {
    return Math.ceil(Math.log2(teams));
  }
}
